(() => {
 'use strict';
 if(window.__TOS291_TOUCH__)return;
 const cfg={enabled:true,actionLabel:'Vezi detaliile sticlei',hintTouch:'Atinge pentru detalii',hintPointer:'Click pentru detalii',movementThreshold:12,hintDurationMs:4200,...window.__TOS291_TOUCH_CONFIG__};
 if(!cfg.enabled)return;
 const entries=new Map(),hintKey='3os:291:detail-hint:v1';
 let hint=null,hintOwner=null,hintTimer=0,tick=0,seen=false;
 try{seen=sessionStorage.getItem(hintKey)==='seen';}catch{}
 const api=()=>window.__R290_MEDIA__;
 const native=()=>window.__THREE_OLIVES_270_R2__;
 const formatOf=stage=>stage.closest('[data-choice-preview]')?.dataset.format||stage.dataset.threeOlivesFormat||(/1000|triathlon-1l|gold/.test(stage.querySelector('img')?.getAttribute('src')||'')?'1000':'500');
 const set=(el,key,value)=>{if(el.getAttribute(key)!==value)el.setAttribute(key,value);};
 const threshold=()=>Math.min(cfg.movementThreshold,api()?.config.dragThreshold||9);
 function hideHint(consumed=false){
  clearTimeout(hintTimer);hintTimer=0;hint?.remove();hint=null;hintOwner=null;
  if(consumed){seen=true;try{sessionStorage.setItem(hintKey,'seen');}catch{}}
 }
 function positionHint(entry){
  if(!hint||!entry)return false;
  const b=entry.stage.getBoundingClientRect(),n=hint.getBoundingClientRect(),safeTop=76,safeBottom=innerHeight-112;
  const top=b.bottom+n.height+8<=safeBottom?b.bottom+8:b.top-n.height-10;
  if(top<safeTop||top+n.height>safeBottom)return false;
  hint.style.left=Math.max(12,Math.min(innerWidth-n.width-12,b.left+b.width/2-n.width/2))+'px';
  hint.style.top=top+'px';return true;
 }
 const visibility=new IntersectionObserver(items=>{
  for(const item of items){const entry=entries.get(item.target);if(entry)entry.visible=item.isIntersecting&&item.intersectionRatio>.7;}
  if(hintOwner&&!entries.get(hintOwner)?.visible)hideHint();
  if(seen||hint||!matchMedia('(pointer:coarse)').matches)return;
  const eligible=[...entries.values()].filter(e=>e.visible&&e.hintSurface.getBoundingClientRect().width>=156&&e.hintSurface.getBoundingClientRect().height>=200).sort((a,b)=>a.stage.getBoundingClientRect().top-b.stage.getBoundingClientRect().top);
  const entry=eligible[0];if(!entry)return;
  hint=document.createElement('span');hint.className='r291-note';hint.textContent=cfg.hintTouch;hint.setAttribute('aria-hidden','true');
  // Scenic art intentionally overflows/crops on mobile. Keep this tiny hint
  // outside that crop, adjacent to the bottle and clear of the fixed buy rail.
  document.body.append(hint);
  if(!positionHint(entry)){hideHint();return;}
  hintOwner=entry.stage;seen=true;
  try{sessionStorage.setItem(hintKey,'seen');}catch{}
  hintTimer=setTimeout(()=>hideHint(true),cfg.hintDurationMs);
 },{threshold:[0,.7,.95]});
 function open(entry){
  if(!api()||api().active)return;
  hideHint(true);api().open(formatOf(entry.stage),entry.button);
 }
 function bind(entry){
  const {stage,button,kind}=entry,abort=new AbortController(),options={capture:true,signal:abort.signal};
  let gesture=null,last=null;
  const clear=(reason='cancel')=>{if(gesture)last={valid:false,at:performance.now(),reason};gesture=null;button.removeAttribute('data-gesture');};
  entry.cancel=clear;entry.destroy=()=>{abort.abort();visibility.unobserve(stage);if(entry.owned)button.remove();if(hintOwner===stage)hideHint();};
  const legacy=()=>native()?.records.get(stage);
  const rotateNative=(pixels,first=false)=>{const n=native(),r=legacy();if(!n||!r)return;if(first||n.viewer.activeRecord!==r)n.viewer.activate(r,{focus:false});n.viewer.rotateByPixels(pixels,r);};
  // Defer the original gold GLB activation until horizontal intent. A tap opens
  // only the lightweight detail viewer, without prewarming a second renderer.
  if(kind==='native')for(const type of ['pointerenter','focus'])button.addEventListener(type,e=>e.stopImmediatePropagation(),options);
  button.addEventListener('pointerdown',e=>{
   if(e.button!==0||e.ctrlKey||e.metaKey||e.altKey||e.shiftKey){clear('modified');return;}
   if(!e.isPrimary&&e.pointerType==='touch'){clear('multitouch');e.stopImmediatePropagation();return;}
   hideHint(true);
   gesture={id:e.pointerId,x:e.clientX,y:e.clientY,lastX:e.clientX,time:performance.now(),distance:0,axis:null,format:formatOf(stage),scroll:scrollY};last=null;
   if(kind==='native'){e.stopImmediatePropagation();try{button.setPointerCapture(e.pointerId);}catch{}}
  },options);
  button.addEventListener('pointermove',e=>{
   if(!gesture||gesture.id!==e.pointerId)return;
   const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
   gesture.distance=Math.max(gesture.distance,Math.hypot(dx,dy));
   if(!gesture.axis&&Math.max(Math.abs(dx),Math.abs(dy))>=threshold()){
    gesture.axis=e.pointerType==='touch'&&button.hasAttribute('data-r298-lock')?'rotate':Math.abs(dx)>Math.abs(dy)*1.12?'rotate':'scroll';button.dataset.gesture=gesture.axis;
    if(gesture.axis==='scroll'){last={valid:false,at:performance.now(),reason:'scroll'};}
   }
   if(kind==='native'){
    e.stopImmediatePropagation();
    if(gesture.axis==='rotate'){rotateNative(e.clientX-gesture.lastX);gesture.lastX=e.clientX;}
    else if(gesture.axis==='scroll'){try{button.releasePointerCapture(e.pointerId);}catch{}clear('scroll');}
   }
  },options);
  button.addEventListener('pointerup',e=>{
   if(kind==='native')e.stopImmediatePropagation();
   if(!gesture||gesture.id!==e.pointerId)return;
   const b=button.getBoundingClientRect();
   // A stationary click has no stopwatch. Scroll, drag, multitouch and an actual
   // contextmenu/pointercancel still cancel; a deliberate slower release does not.
   last={valid:!gesture.axis&&gesture.distance<threshold()&&Math.hypot(e.clientX-gesture.x,e.clientY-gesture.y)<threshold()&&Math.abs(scrollY-gesture.scroll)<3&&gesture.format===formatOf(stage)&&e.clientX>=b.left&&e.clientX<=b.right&&e.clientY>=b.top&&e.clientY<=b.bottom,at:performance.now()};
   gesture=null;button.removeAttribute('data-gesture');
   if(e.pointerType==='touch'&&last.valid)api().activateTouch(e,button,()=>open(entry));
  },options);
  button.addEventListener('pointercancel',()=>clear('pointercancel'),options);
  button.addEventListener('lostpointercapture',()=>{if(gesture)clear('lostpointercapture');},options);
  button.addEventListener('click',e=>{
   e.preventDefault();e.stopImmediatePropagation();
   if(e.button!==0||e.ctrlKey||e.metaKey||e.altKey||e.shiftKey)return;
   const recent=last&&performance.now()-last.at<1200;
   // Keyboard, switch and voice activation are native clicks with detail=0;
   // they never depend on the timing of the preceding pointer interaction.
   if(e.detail!==0&&(!recent||!last.valid))return;
   last=null;open(entry);
  },options);
  button.addEventListener('keydown',e=>{
   if(e.key==='Enter'||e.key===' '){last=null;gesture=null;if(kind==='native')e.stopImmediatePropagation();if(kind==='link'){e.preventDefault();if(e.key==='Enter'&&!e.repeat)open(entry);}}
   if(kind==='native'&&['ArrowLeft','ArrowRight','Home'].includes(e.key)){
    e.preventDefault();e.stopImmediatePropagation();hideHint(true);
    if(e.key==='Home'){if(native()?.viewer.activeRecord===legacy())native().viewer.reset();}
    else rotateNative(e.key==='ArrowLeft'?-26:26,true);
   }
  },options);
  button.addEventListener('keyup',e=>{if(kind==='link'&&e.key===' '){e.preventDefault();if(document.activeElement===button)open(entry);}},options);
  button.addEventListener('contextmenu',()=>clear('longpress'),options);
  visibility.observe(stage);
 }
 function upgrade(stage){
  if(entries.has(stage))return;
  const image=stage.querySelector('img');if(!image)return;
  let button=stage.querySelector('.r290-turn'),kind=button?'cycles':null,owned=false;
  if(!button){button=stage.querySelector('.three-olives-270__activate');if(button)kind='native';}
  if(!button){
   if(stage.hasAttribute('data-three-olives-stage'))return; // wait for its existing engine
   if(stage.matches('a.c286-photo')){button=stage;kind='link';button.setAttribute('role','button');}
   else{
    if(stage.closest('button,a,label'))return; // selectors and other navigation retain their job
    button=document.createElement('button');button.type='button';button.className='r291-hit';stage.append(button);kind='poster';owned=true;
   }
  }
  if(getComputedStyle(stage).position==='static')stage.dataset.r291Positioned='';
  button.dataset.r291Kind=kind;button.classList.add('r291-touch');button.setAttribute('aria-haspopup','dialog');
  // One-finger contact on the actual bottle belongs to rotation for its entire
  // lifetime. Browser pinch is retained; page scrolling remains outside it.
  if(api().config.lockInlineTouch&&kind!=='link')button.setAttribute('data-r298-lock','');
  if(api().config.cleanBottleUI){
   stage.setAttribute('data-r298-clean','');
   // Inline orientation badges add noise over the supplied product renders.
   // The gallery reset and the bottle's Home key remain available.
   stage.querySelectorAll('.r290-reset,[data-three-olives-reset]').forEach(control=>{
    control.textContent='';control.tabIndex=-1;control.setAttribute('aria-hidden','true');
   });
  }
  const entry={stage,button,kind,owned,visible:false,hintSurface:stage.matches('.hero-bottle')?stage.closest('.hero-art'):stage};entries.set(stage,entry);bind(entry);
  if(kind==='poster')api().registerPoster?.(stage,button,()=>formatOf(stage));
  stage.dataset.r291Ready='';
  // Remove the visual launcher without altering any image/camera geometry.
  const parent=stage.closest('button,a')?.parentElement||stage;
  for(const old of parent.querySelectorAll(':scope > .r290-expand'))old.dataset.r291Obsolete='';
  stage.closest('[data-choice-preview]')?.querySelector('[data-3d-open]')?.setAttribute('data-r291-obsolete','');
 }
 function scan(){
  if(!api())return;
  document.querySelectorAll('[data-three-olives-stage],.hero-bottle,.c286-photo,.pick-object').forEach(upgrade);
  for(const [stage,e]of entries){
   if(!stage.isConnected||!e.button.isConnected){e.destroy();entries.delete(stage);continue;}
   set(e.button,'aria-label',cfg.actionLabel+' Picual '+(formatOf(stage)==='1000'?'1 L':'500 ml'));
   set(e.button,'data-r291-kind',e.kind);
   if(e.kind==='poster')api().records.get(stage)?.sync?.();
   const parent=stage.closest('button,a')?.parentElement||stage;
   parent.querySelectorAll(':scope > .r290-expand').forEach(b=>set(b,'data-r291-obsolete',''));
  }
 }
 const observer=new MutationObserver(()=>{tick ||= requestAnimationFrame(()=>{tick=0;scan();});});
 observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','data-format','data-three-olives-format']});
 document.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'&&!e.isPrimary)entries.forEach(x=>x.cancel('multitouch'));},true);
 document.addEventListener('scroll',()=>{entries.forEach(x=>x.cancel('scroll'));if(hint&&!positionHint(entries.get(hintOwner)))hideHint(true);},true);
 window.addEventListener('resize',()=>{if(hint)hideHint(true);});
 window.addEventListener('blur',()=>entries.forEach(x=>x.cancel('blur')));
 scan();requestAnimationFrame(scan);
 window.__TOS291_TOUCH__={entries,config:cfg,scan,version:'298-locked-touch-v1'};
})();
